function _(n,t,e){t.exports=function(n){return"number"==typeof n&&n%1==0}}
//# sourceMappingURL=shim.min.js.map